import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { TopicLink } from "scmp-app/components/topic/topic-link";

export const StyledTopicLink = styled(TopicLink)`
  display: block;

  color: #001246;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};
  line-height: 16px;
`;
